import StoreBuilder from '../store-builder';

import { findIndex } from 'lodash';

const builder = new StoreBuilder('cart');
builder.addStatePart('index', 1, null, 'SESSION');
builder.addStatePart('cart', [], null, 'SESSION');
builder.addStatePart('datesLivraisonDefaut', [], null, 'SESSION');
builder.addStatePart('commentairesPanier', {}, null, 'SESSION');
builder.addStatePart('periodesLivraisonDefaut', [], null, 'SESSION');

builder.setMutations({
  INCREMENT_INDEX (state) {
    state.index += 1;
  },
  ADD_LINE_TO_CART (state, line) {
    state.cart.push(line);
  },
  REMOVE_LINE_FROM_CART (state, index) {
    state.cart.splice(index, 1);
  },
  UPDATE_CART_LINE (state, { index, line }) {
    state.cart.splice(index, 1, line);
  }
});
builder.setGetters({
  nbLines: state => state.cart.length,
  line: state => index => state.cart[index]
});

function buildIndex (commit, state) {
  let index;
  do {
    index = ('000' + state.index).slice(-3);
    commit('INCREMENT_INDEX');
    commit('STORE_INDEX');
  } while (findIndex(state.cart, { idLigne: index }) !== -1);

  return index;
}

builder.setActions({
  addLine ({ commit, state }, line) {
    line.idLigne = buildIndex(commit, state);

    commit('ADD_LINE_TO_CART', line);
    commit('STORE_CART');
    commit('SET_DATESLIVRAISONDEFAUT', { dateDebut: line.datePrevueLivraison, dateFin: line.finDatePrevueLivraison });
    commit('SET_PERIODESLIVRAISONDEFAUT', { horaireDebut: line.matinApmidi, horaireFin: line.finMatinApmidi });
  },
  updateLine ({ commit, state }, { oldLine, newLine }) {
    const index = typeof oldLine === 'number'
      ? oldLine
      : findIndex(state.cart, { idLigne: oldLine.idLigne });

    if (index === -1) {
      // eslint-disable-next-line no-console
      console.error('cart : try to update unknown line', oldLine.idLigne, state.cart.map(l => l.idLigne));
      return;
    }

    commit('UPDATE_CART_LINE', { index, line: newLine });
    commit('STORE_CART');
    commit('SET_DATESLIVRAISONDEFAUT', { dateDebut: newLine.datePrevueLivraison, dateFin: newLine.finDatePrevueLivraison });
    commit('SET_PERIODESLIVRAISONDEFAUT', { horaireDebut: newLine.matinApmidi, horaireFin: newLine.finMatinApmidi });
  },
  removeLine ({ commit, state }, line) {
    const index = typeof line === 'number'
      ? line
      : findIndex(state.cart, { idLigne: line.idLigne });
    if (index !== -1) {
      commit('REMOVE_LINE_FROM_CART', index);
      commit('STORE_CART');
    }
  }
});

export default builder.build();
